import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './Receipt.css'
import ReffedRender from './RenderReceipt'
import html2pdf from 'html2pdf.js'
import Patient from '../../../../../models/Patient/Patient'
import withPolyglot from '../../../../common/withPolyglot'

import rightIcon from './rightIcon.png'
import leftIconDE from './leftIconDE.png'
import leftIconBR from './leftIconBR.png'
import leftIconPT from './leftIconPT.png'
import leftIconEN from './leftIconEN.png'

import centerIconDE from './centerIconDE.png'
import centerIconBR from './centerIconBR.png'
import centerIconPT from './centerIconPT.png'
import centerIconEN from './centerIconEN.png'
// import ImmunizationRecommendation from '../../../../../models/ImmunizationRecommendion/ImmunizationRecommendation'

class Receipt extends Component {
  constructor (props) {
    super(props)
    this.receiptRef = React.createRef()
  }

  generate () {
    const domRef = this.receiptRef.current
    console.log(html2pdf().from(domRef).set({pagebreak: ''}).to('pdf').output('bloburi').then(result => {
      console.log(`Result: ${result}`)
      const tab = window.open(result, '_blank')
      if (tab) {
        // tab.document.title = `Recibo ${this.props.patient.name}`
        setTimeout(() => {
          URL.revokeObjectURL(result)
        }, 10000)
      }
    }))
  }

  render () {
    const {patient, immunizations, nextImmunizations, pathologies, translate, currentLocale} = this.props
    let logos = []
    if (currentLocale === 'br') {
      logos = [
        {
          url: rightIcon,
          alt: 'logo1',
          height: 90,
          width: 90
        },
        {
          url: centerIconBR,
          alt: 'logo2',
          height: 90,
          width: 67
        },
        {
          url: leftIconBR,
          alt: 'logo3',
          height: 50,
          width: 50
        }
      ]
    } else if (currentLocale === 'pt') {
      logos = [
        {
          url: rightIcon,
          alt: 'logo1',
          height: 90,
          width: 90
        },
        {
          url: centerIconPT,
          alt: 'logo2',
          height: 90,
          width: 67
        },
        {
          url: leftIconPT,
          alt: 'logo3',
          height: 50,
          width: 50
        }
      ]
    } else if (currentLocale === 'de') {
      logos = [
        {
          url: rightIcon,
          alt: 'logo1',
          height: 90,
          width: 90
        },
        {
          url: centerIconDE,
          alt: 'logo2',
          height: 90,
          width: 67
        },
        {
          url: leftIconDE,
          alt: 'logo3',
          height: 50,
          width: 50
        }
      ]
    } else {
      logos = [
        {
          url: rightIcon,
          alt: 'logo1',
          height: 90,
          width: 90
        },
        {
          url: centerIconEN,
          alt: 'logo2',
          height: 90,
          width: 67
        },
        {
          url: leftIconEN,
          alt: 'logo3',
          height: 50,
          width: 50
        }
      ]
    }
    return (
      <div>
        <button
          className='uk-button uk-margin-small-top uk-button-primary uk-align-center'
          onClick={() => this.generate()}>
          {translate('openNewTab')}
        </button>
        <ReffedRender
          currentLocale={currentLocale}
          immunizations={immunizations}
          pathologies={pathologies}
          patient={patient}
          ref={this.receiptRef}
          logos={logos}
          nextImmunizations={nextImmunizations} />
      </div>
    )
  }
}

Receipt.propTypes = {
  patient: PropTypes.instanceOf(Patient).isRequired,
  pathologies: PropTypes.array.isRequired,
  nextImmunizations: PropTypes.array.isRequired,
  plan: PropTypes.object
}

export default withPolyglot(Receipt, 'receipt')
